export const SEARCH_GUEST_USER_REQUESTED = 'deactivateGuest/SEARCH_GUEST_USER_REQUESTED';
export const SEARCH_GUEST_USER_SUCCESS = 'deactivateGuest/SEARCH_GUEST_USER_SUCCESS';
export const SEARCH_GUEST_USER_FAILURE = 'deactivateGuest/SEARCH_GUEST_USER_FAILURE';
export const RESET_GUEST_USER_DATA = 'deactivateGuest/RESET_GUEST_USER_DATA';
export const DEACTIVATE_GUEST_USER_REQUESTED = 'deactivateGuest/DEACTIVATE_GUEST_USER_REQUESTED';
export const DEACTIVATE_GUEST_USER_SUCCESS = 'deactivateGuest/DEACTIVATE_GUEST_USER_SUCCESS';
export const DEACTIVATE_GUEST_USER_FAILURE = 'deactivateGuest/DEACTIVATE_GUEST_USER_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  guestListData: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_GUEST_USER_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case SEARCH_GUEST_USER_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        guestListData: action.result,
      };
    }
    case SEARCH_GUEST_USER_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case RESET_GUEST_USER_DATA: {
      return {
        ...state,
        guestListData: action.payload,
      };
    }
    case DEACTIVATE_GUEST_USER_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case DEACTIVATE_GUEST_USER_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
      };
    }
    case DEACTIVATE_GUEST_USER_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    default: return state;
  }
};


export const searchGuestUser = (data) => {
  return {
    types: [SEARCH_GUEST_USER_REQUESTED, SEARCH_GUEST_USER_SUCCESS, SEARCH_GUEST_USER_FAILURE],
    promise: client => client.post('searchGuestUser', { data })
  };
};

export const resetGuestUserData = () => {
  return {
    type: RESET_GUEST_USER_DATA,
    payload: [],
  };
};

export const deactivateGuestUser = (id) => {
  return {
    types: [DEACTIVATE_GUEST_USER_REQUESTED, DEACTIVATE_GUEST_USER_SUCCESS, DEACTIVATE_GUEST_USER_FAILURE],
    promise: client => client.post(`deactivateGuestUser/${id}`)
  };
};
